import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
import LazyLoad from 'react-lazyload'
const BookList = () => {
     useEffect(() => {
        document.title = 'List of Books -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Academics  </li> 
     <li>List of Books </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>List of Books  </h1>
         </div>
     </div>
     <div className="row">
       <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_Nur.pdf" target="_blank">
          <div class="sample-blk">
              <p> Nursery</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_LKG.pdf" target="_blank">
          <div class="sample-blk">
              <p> LKG</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_UKG.pdf" target="_blank">
          <div class="sample-blk">
              <p> UKG</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_classI.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class I</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassII.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class II</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassIII.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class III</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassIV.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class IV</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassV.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class V</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassVI.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class VI</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassVII.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class VII</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassVIII.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class VIII</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassIX.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class IX</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
      <div class="col-lg-4 col-md-6">
        <Link to="https://webapi.entab.info/api/image/STPSFH/public/pdf/BOOK_LIST_ClassX.pdf" target="_blank">
          <div class="sample-blk">
              <p> Class X</p>
              <LazyLoad><img alt="STPCSH" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png" class="img-fluid"/></LazyLoad>
          </div>
        </Link>
      </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default BookList
